import './SettingsStep.scss'

import React, {Component} from 'react'
import { Button } from 'react-bootstrap'

import { push } from 'react-router-redux'

class SettingsStep extends Component {

  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    if (!this.props.noRedirect && Object.keys(this.props.settings).length === 0) {
      this.props.dispatch(push({pathname:'/settings'}))
    }
  }

  handleSubmit() {
    this.props.onSubmit(() => this.props.dispatch(push({pathname:'/settings'})))
  }

  render() {
    const {children, shouldDisableSubmit, settings} = this.props

    return <div className="SettingsStep">
      <div className="SettingsStep__content">
        { Object.keys(settings).length !== 0 ? children : null }
      </div>
      <div className="SettingsStep__footer">
        <Button bsStyle="success" disabled={shouldDisableSubmit} onClick={this.handleSubmit}>Save</Button>
      </div>
    </div>
  }
}

export default SettingsStep
